module.exports = __webpack_public_path__ + "static/KabImg-fa06d4d21db5326647652bdb4f3b5490.jpg";